module.exports = __webpack_public_path__ + "static/media/ai.91136889.svg";